import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useFilterStyles = makeStyles({
  filterContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("8px"),
    ...shorthands.padding("8px"),
    background: "linear-gradient(180deg, #D3E8D9 0%, #EEEEEE 79.45%)",
    flexGrow: 1,
  },
  filterHeader: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("4px"),
    marginBottom: "16px",
    width: "100%",
    maxWidth: "100%",
  },
  filterContent: {
    display: "flex",
    flexDirection: "column",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
    width: "100%",
    maxWidth: "100%",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("8px"),
    marginBottom: "16px",
    width: "100%",
    maxWidth: "100%",
    margin: "0 0 16px 0",
    "@media (min-width: 400px)": {
      maxWidth: "100%",
    },
    "@media (min-width: 600px)": {
      maxWidth: "100%",
    },
  },
  inputContainer: {
    position: "relative",
    width: "100%",
  },
  searchInput: {
    width: "100%",
    "& input": {
      height: "44px",
      ...shorthands.padding("12px", "48px", "12px", "12px"),
      fontSize: "13px",
      ...shorthands.border("1px", "solid", "#E5E7EB"),
      ...shorthands.borderRadius("10px"),
      backgroundColor: tokens.colorNeutralBackground1,
      "&::placeholder": {
        color: "#9AA3AF",
      },
      "&:focus": {
        ...shorthands.outline("none"),
        ...shorthands.border("2px", "solid", "#3B82F6"),
        boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.1)",
      },
    },
  },
  inputIcon: {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "28px",
    height: "28px",
    ...shorthands.borderRadius("50%"),
    backgroundColor: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    zIndex: 1,
  },
  dropdown: {
    width: "100%",
    "& > button": {
      height: "44px",
      ...shorthands.borderRadius("10px"),
      ...shorthands.border("1px", "solid", "#E5E7EB"),
      fontSize: "13px",
      ...shorthands.padding("12px", "48px", "12px", "12px"),
      backgroundColor: tokens.colorNeutralBackground1,
      "&:focus": {
        ...shorthands.outline("none"),
        ...shorthands.border("2px", "solid", "#3B82F6"),
        boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.1)",
      },
      "&:hover": {
        backgroundColor: tokens.colorNeutralBackground1,
        ...shorthands.border("1px", "solid", "#E5E7EB"),
      },
    },
  },
  dropdownIcon: {
    position: "absolute",
    right: "36px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "28px",
    height: "28px",
    ...shorthands.borderRadius("50%"),
    backgroundColor: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    zIndex: 1,
  },
  labelText: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#1F2937",
    marginBottom: "4px",
  },
  dateRangeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ...shorthands.gap("8px"),
    width: "100%",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    maxWidth: "100%",
  },
  dateInputWrapper: {
    flex: 1,
    position: "relative",
  },
  dateInput: {
    width: "100%",
    height: "44px",
    ...shorthands.padding("12px", "48px", "12px", "12px"),
    ...shorthands.border("1px", "solid", "#E5E7EB"),
    ...shorthands.borderRadius("10px"),
    fontSize: "13px",
    fontFamily: "inherit",
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    boxSizing: "border-box",
    "&::placeholder": {
      color: "#9AA3AF",
    },
    "&:focus": {
      ...shorthands.outline("none"),
      ...shorthands.border("2px", "solid", "#3B82F6"),
      boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.1)",
    },
    "&:disabled": {
      backgroundColor: "#F3F4F6",
      color: "#9CA3AF",
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },
  dateIcon: {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "28px",
    height: "28px",
    ...shorthands.borderRadius("50%"),
    backgroundColor: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    zIndex: 1,
  },
  dateRangeSeparator: {
    color: "#9CA3AF",
    fontWeight: "500",
    fontSize: "12px",
    textAlign: "center",
    minWidth: "14px",
    flexShrink: 0,
  },
  selectedDatesDisplay: {
    ...shorthands.padding("8px", "12px"),
    ...shorthands.borderRadius("8px"),
    backgroundColor: "#F3F4F6",
    ...shorthands.border("1px", "solid", "#E5E7EB"),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    ...shorthands.gap("6px"),
    marginTop: "8px",
    fontSize: "12px",
    width: "100%",
    boxSizing: "border-box",
  },
  actionButtons: {
    display: "flex",
    ...shorthands.gap("16px"),
    justifyContent: "center",
    width: "100%",
    maxWidth: "280px",
    margin: "24px auto 0 auto",
  },
  actionButton: {
    flex: 1,
    height: "44px",
    fontSize: "14px",
    fontWeight: "500",
    ...shorthands.borderRadius("10px"),
    "&:focus-visible": {
      ...shorthands.outline("none"),
      boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.1)",
    },
  },
  cancelButton: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border("1.5px", "solid", "#3B82F6"),
    color: "#3B82F6",
    "&:hover": {
      backgroundColor: "#EFF6FF",
      ...shorthands.border("1.5px", "solid", "#3B82F6"),
    },
    "&:active": {
      backgroundColor: "#DBEAFE",
    },
  },
  applyButton: {
    backgroundColor: "#2563EB",
    color: tokens.colorNeutralBackground1,
    ...shorthands.border("none"),
    "&:hover": {
      backgroundColor: "#1D4ED8",
    },
    "&:active": {
      backgroundColor: "#1E40AF",
    },
    "&:disabled": {
      backgroundColor: "#9CA3AF",
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },
  // Keeping legacy styles that might be used elsewhere but not shown in design
  quickDateButtons: {
    display: "flex",
    ...shorthands.gap("4px"),
    flexWrap: "wrap",
    marginTop: "6px",
  },
  quickDateButton: {
    minWidth: "auto",
    fontSize: "11px",
    padding: "4px 8px",
  },
  dateButton: {
    width: "100%",
    justifyContent: "space-between",
    fontSize: "12px",
  },
  statusMessage: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap("6px"),
    ...shorthands.padding("6px", "8px"),
    ...shorthands.borderRadius("4px"),
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground2,
    marginBottom: "6px",
    fontSize: "12px",
    width: "85%",
    alignSelf: "center",
  },
  loginButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    ...shorthands.gap("8px"),
    width: "100%",
    maxWidth: "280px",
    margin: "0 auto 16px auto",
  }
});